import React from "react";
import AppLayout from "../../components/AppLayout/AppLayout";
import FileExplorer from "../../components/FileExplorer/FileExplorer";
import { Grid } from "@mui/material";


const DocumentManagement = () => {

  return (
    <AppLayout>
      <Grid container justifyContent="center" spacing={4}>
      
          <Grid item xs={10.8} style={{ marginBottom: "20px" }}>

<FileExplorer /> </Grid>
</Grid>
     
    </AppLayout>
  );
};

export default DocumentManagement;
